import styled from 'styled-components';

import colors from 'themes/Main';

const { gray03, darkBlue, gray01 } = colors;

export const Small = styled.small`
  display: block;
  margin: -16px 0 16px;
  color: ${gray03};
  font-size: 14px;
  font-weight: 600;
`;

export const MediationArea = styled.div`
  margin-top: 16px;
`;

export const AreaName = styled.h3`
  margin-bottom: 8px;
  font-size: 20px;
  font-weight: 700;
  color: ${darkBlue};

  &:not(:first-child) {
    margin-top: 32px;
  }
`;

export const Question = styled.p`
  width: 80%;
  margin-bottom: 0;
  color: ${gray01};
`;
